import { logger } from '../utils/log'
import type { IMessageClient, MessageOptions, MessageCallback } from './IMessageClient'
import ReconnectingWebSocket from 'reconnecting-websocket'
import { healthy } from './api'

/**
 * websocket消息信息
 */
class WebsocketMessageClient implements IMessageClient {
  callbackList: MessageCallback[] = []
  wsClient: ReconnectingWebSocket | undefined = undefined
  options: MessageOptions | undefined = undefined
  hasConnected = false

  init(options: MessageOptions): void {
    this.options = options

    if (this.wsClient) {
      this.wsClient.close(1)
    }
    const testHost = 'wss://owork-api-cn-test.wanyol.com/ws-owork-server'

    if (!this.options?.wsAddress) {
      this.options.wsAddress = testHost
    }
    console.log('ws 开启了')
    this.wsClient = new ReconnectingWebSocket(this.options.wsAddress, [], {
      maxRetries: this.options.retries || 50, //重试次数
      connectionTimeout: 15000, // retry connect if not connected after this time, in ms
      // debug: true
    })

    this.wsClient.onopen = (e: any) => {
      console.log('websocket connect success', e)
      this.onConnected()
      this.hasConnected = true
    }

    this.wsClient.onmessage = (e: any) => {
      this.onMessageArrived(e)
    }

    this.wsClient.onerror = (e: any) => {
      console.log('websocket connect error', e)
      this.onConnectionLost(e)
      this.onFailure(e)
    }

    this.wsClient.onclose = (e: any) => {
      console.log('websocket 关闭了', e)

      if (e.code !== 1 || e.code == 1006) {
        /* 检测token是否过期 */
        const url = options.apiAddress + '/owork-server/web/common/healthy'

        healthy(url).then((res: any) => {
          console.log(res)

          if (res.code !== 0) {
            this.close()
          }
        })
      }
    }
  }

  // called when the client connects
  onConnected = () => {
    logger.log('onConnected')
  }

  onFailure = (e: any) => {
    logger.log('Connect failed')
    logger.log(e)
  }

  // called when the client loses its connection
  onConnectionLost = (responseObject: any) => {
    if (responseObject.errorCode !== 0) {
      logger.log('onConnectionLost:' + responseObject.errorMessage, new Error())
    }

    for (const listeners of this.callbackList) {
      listeners.onConnectionLost(responseObject)
    }
  }

  // called when a message arrives
  onMessageArrived = (message: any) => {
    logger.log('onMessageArrived:' + message.data)

    for (const listener of this.callbackList) {
      if (this.options) {
        listener.onMessageArrived(message.data)
      }
    }
  }

  registerCallback(messageCallback: MessageCallback): boolean {
    if (this.callbackList.indexOf(messageCallback) >= 0) {
      return true
    }

    return this.callbackList.push(messageCallback) > 0
  }

  removeCallback(messageCallback: MessageCallback) {
    this.callbackList = this.callbackList.filter((i) => i === messageCallback)
  }

  removeAllCallbacks(): void {
    this.callbackList = []
  }

  // 1 : 自己关闭  非1: 服务器关闭
  close(): void {
    if (this.wsClient) {
      this.wsClient.close(1)
    }
    this.wsClient = undefined
    this.hasConnected = false
  }
}

export const messageClient = new WebsocketMessageClient()
